import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import { FaListAlt, FaPlus, FaVideo } from "react-icons/fa";
import { MdDelete, MdFileDownload, MdModeEdit, MdVideoLibrary } from "react-icons/md";
import { Link, useHistory, useParams } from "react-router-dom";
import Search from "../ReusableComponents/Search";

import { Button } from "react-bootstrap";
import Request from "../../Request";
import Pagination from '@material-ui/lab/Pagination';
import { BsFillEyeFill } from "react-icons/bs";
import { logout } from "../../actions/AppActions";
import { useDispatch } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import moment from "moment";
import { saveAs } from 'file-saver';
import ModalCandidatosCsv from "./ModalCandidatosCsv";
import { THIS_URL } from "../../variables";
import StatusBadge, { getAttendanceStatus, getReliabilityStatus } from "../ReusableComponents/StatusBadge";
import TableEmptyState from '../ReusableComponents/TableEmptyState';

const TRUST_METRICS = [
  { key: "acoes_relatadas", labelKey: "trust_metric_reported_actions" },
  { key: "average_face", labelKey: "trust_metric_face_recognition_average" },
  { key: "face_validaiton_again", labelKey: "trust_metric_periodic_face_validations" },
  { key: "no_face", labelKey: "trust_metric_photos_without_face" },
  { key: "request_validation", labelKey: "trust_metric_fiscal_release_requests" },
  { key: "saidas", labelKey: "trust_metric_screen_exits" },
  { key: "tempo", labelKey: "trust_metric_screen_exit_time" },
  { key: "video_no_face", labelKey: "trust_metric_videos_without_face" },
  { key: "video_multiple_faces", labelKey: "trust_metric_multiple_faces_videos" },
  { key: "ip_equal", labelKey: "trust_metric_identical_ips" },
];

const VIDEO_AI_EVENTS = [
  "AI_ASSISTANT",
  "BOOK",
  "CALCULATOR",
  "CELL_PHONE",
  "EARBUDS",
  "EMAIL",
  "EXTERNAL_WEBSITE",
  "HEADPHONES",
  "LAPTOP",
  "LONG_HAIR",
  "BROWSER_NEW_TAB",
  "LOOKING_AWAY",
  "MESSAGING",
  "MULTIPLE_FACES",
  "MULTIPLE_PEOPLE",
  "MULTIPLE_SPEAKERS",
  "NO_PERSON",
  "PAPER",
  "PERSON",
  "REFERENCE",
  "SEARCH_ENGINE",
  "SECOND_SPEAKER",
  "SPEECH",
  "START_MENU",
  "SMARTWATCH",
  "TV_MONITOR",
  "UNKNOWN",
];

const defaultTrustOptions = () => ({
  metrics: TRUST_METRICS.reduce((options, item) => ({ ...options, [item.key]: true }), {}),
  ai_events: VIDEO_AI_EVENTS.reduce((options, item) => ({ ...options, [item]: true }), {}),
});

const translatedKey = (t, key, fallback = key) => {
  const value = t(key);
  return value === key ? fallback : value;
};

const getVideoAIEventLabel = (t, eventType) => {
  if (eventType === "NO_FACE") return t("video_ai_event_no_person");
  return translatedKey(t, `video_ai_event_${String(eventType || "").toLowerCase()}`, eventType || "-");
};



const CandidatosConfiabilidade = (props) => {const { t } = usePreferences();

  const [lesson_cards, SetLessonCards] = useState(null);
  const [loading_screen, setLoadingScreen] = useState(true);
  const [loading_candidatos, setLoadingcandidatos] = useState(false);
  const [search_oficial, setSearchOficial] = useState('');
  const [msgStatus, setMsgStatus] = useState('');
  const [link, setLink] = useState('');



  const [candidatos, setcandidatos] = useState([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1 });



  const [search, setSearch] = useState('');
  const { processo_id, processo_name } = props;
  const [show_warning, setShowWarning] = useState(false);
  const [candidatos_id, setRedacaoId] = useState(null);


  const [questaoSelect, setQuestaoSelect] = useState({});

  const [showModal, setShowModal] = useState(false);
  let refs = [];
  const dispatch = useDispatch();

  const [loading_zip, setLoadingZip] = useState(false);
  const [message_zip, setMessageZip] = useState('');

  const [loading_zip2, setLoadingZip2] = useState(false);
  const [message_zip2, setMessageZip2] = useState('');
  const timerRef = useRef(null);
  const [trustOptions, setTrustOptions] = useState(defaultTrustOptions());
  const [hasReport, setHasReport] = useState(false);

  const buildTrustOptionsQuery = (options) => encodeURIComponent(JSON.stringify(options));

  const Getcandidatos = async (generate = false, options = trustOptions) => {
    setLoadingScreen(true);
    let response = await Request.Get(`faculdade/get_trust_values/${processo_id}?generate=${generate ? 1 : 0}&trust_options=${buildTrustOptionsQuery(options)}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    if (response.status == true) {
      let candidatos = JSON.parse(response.content).sort(function (a, b) {
        return b.trust_points - a.trust_points;
      });
      setLink(response.link);
      setcandidatos(candidatos);
      setHasReport(true);
      setMsgStatus('');
      setLoadingScreen(false);
      setLoadingcandidatos(false);


    } else if (response.status == null)
    {
      setLink('');
      setcandidatos([]);
      setHasReport(false);
      setMsgStatus(response.message || t("trust_report_not_generated"));
      setLoadingScreen(false);
      setLoadingcandidatos(false);
    } else
    {
      setLink('');
      setHasReport(false);
      setMsgStatus(response.message);
      timerRef.current = setTimeout(() => {
        Getcandidatos(false, options);
      }, 20000);
    }
  };

  const setAllTrustOptions = (enabled) => {
    setTrustOptions({
      metrics: TRUST_METRICS.reduce((options, item) => ({ ...options, [item.key]: enabled }), {}),
      ai_events: VIDEO_AI_EVENTS.reduce((options, item) => ({ ...options, [item]: enabled }), {}),
    });
  };

  const toggleTrustOption = (group, key) => {
    setTrustOptions(current => ({
      ...current,
      [group]: {
        ...current[group],
        [key]: current[group][key] === false,
      },
    }));
  };

  const generateTrustReport = () => {
    clearTimeout(timerRef.current);
    setLoadingcandidatos(true);
    Getcandidatos(true, trustOptions);
  };

  const getCandidateAIEventRows = (trust) => {
    const details = trust?.video_ai_event_details || {};
    return Object.keys(details).map(eventType => ({
      eventType,
      label: getVideoAIEventLabel(t, eventType),
      total: details[eventType]?.total || 0,
      points: Number(details[eventType]?.points || 0),
      enabled: details[eventType]?.enabled !== false,
    })).sort((a, b) => b.points - a.points);
  };


  useEffect(() => {
    Getcandidatos(false, trustOptions);

    return () => {
      clearTimeout(timerRef.current);
    };
  }, []);


  let pesquisarTimeout = null;
  const history = useHistory();
  return (
    <div className="row">

            <div className="col-12">


                {/* <hr /> */}
                {loading_screen == false && <div>

                    <p className="text-muted">{t("ui_aqui_ficam_a_confiabilidade_dos_candidatos_no_d344db7b")}{processo_name}{t("ui_quanto_menor_o_valor_mais_confiavel_6654eba4")}</p>

                    {/* <h4 className="mt-0 header-title" style={{ fontSize: '1.2rem', color: 'black', textAlign: 'center' }}>Questões</h4> */}
                    {/* <br /> */}
                    <div className="trust-options-panel mb-4">
                        <div className="trust-options-header">
                            <div>
                                <p className="trust-options-title">{t("trust_options_title")}</p>
                                <p className="trust-options-description">{t("trust_options_description")}</p>
                            </div>
                            <div className="trust-options-actions">
                                <Button variant="outline-secondary" size="sm" onClick={() => setAllTrustOptions(true)}>
                                    {t("action_select_all")}
                                </Button>
                                <Button variant="outline-secondary" size="sm" onClick={() => setAllTrustOptions(false)}>
                                    {t("action_clear_selection")}
                                </Button>
                            </div>
                        </div>
                        <div className="trust-options-groups">
                            <div>
                                <strong>{t("trust_metrics_title")}</strong>
                                <div className="trust-options-grid">
                                    {TRUST_METRICS.map(metric => (
                                        <label key={metric.key} className={trustOptions.metrics[metric.key] !== false ? "trust-option-item" : "trust-option-item disabled"}>
                                            <input
                                                type="checkbox"
                                                checked={trustOptions.metrics[metric.key] !== false}
                                                onChange={() => toggleTrustOption("metrics", metric.key)}
                                            />
                                            <span>{t(metric.labelKey)}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <strong>{t("trust_ai_events_title")}</strong>
                                <div className="trust-options-grid">
                                    {VIDEO_AI_EVENTS.map(eventType => (
                                        <label key={eventType} className={trustOptions.ai_events[eventType] !== false ? "trust-option-item" : "trust-option-item disabled"}>
                                            <input
                                                type="checkbox"
                                                checked={trustOptions.ai_events[eventType] !== false}
                                                onChange={() => toggleTrustOption("ai_events", eventType)}
                                            />
                                            <span>{getVideoAIEventLabel(t, eventType)}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="flex jcsb flex-wrap mb-4">

                        <Search className="mt-2" placeholder={t("legacy_pesquisar_pelo_nome_do_candidato")} ValueChange={(value) => {
              setSearchOficial(value);
            }} />





                        <div className=" mt-2" style={{
              height: 'max-content',
              justifyContent: 'flex-end'
            }}>


                            <div className="d-flex " style={{
                gap: 8,
                justifyContent: 'flex-end'
              }}>








                                <Button variant="primary" className="flex align-center jcc" onClick={generateTrustReport} disabled={loading_candidatos}>
                                    {loading_candidatos ? <CircularProgress size={16} style={{ marginRight: 8 }} /> : <FaPlus style={{ marginRight: 10 }} />}
                                    <p style={{ margin: 0 }}>{t("action_generate_report")}</p>
                                </Button>

                                {hasReport && link && <a href={link} target="_blank" rel="noreferrer" style={{ textDecoration: "none", marginRight: 5 }}>
                                    {<Button variant="success" className="flex align-center jcc"><MdFileDownload style={{ marginRight: 10 }} /> <p style={{ margin: 0 }}>{t("action_download_report")}</p></Button>}

                                </a>}
                            </div>





                        </div>

                    </div>

                    <div className="table-modern-card">
                        <div className="table-modern-scroll">
                            <table id="tech-companies-1" className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>{t("legacy_tipo")}</th>
                                        <th>{t("label_name")}</th>
                                        <th>{t("legacy_inscricao")}</th>

                                        <th>{t("label_email")}</th>
                                        <th>{t("legacy_cpf")}</th>
                                        <th>{t("legacy_sala")}</th>
                                        <th>{t("label_module_status")}</th>

                                        <th>{t("title_reliability")}</th>

                                        <th>{t("label_actions")}</th>



                                    </tr>
                                </thead>
                                <tbody>
                                    {loading_candidatos == false && candidatos.
                  filter((item, id) => {
                    if (item.name.toLowerCase().includes(search_oficial.toLowerCase()) ||
                    item.cpf.toLowerCase().includes(search_oficial.toLowerCase()) ||
                    item.numero_inscricao.toLowerCase().includes(search_oficial.toLowerCase()) ||
                    item.email.toLowerCase().includes(search_oficial.toLowerCase()))
                    {
                      return true;
                    }
                    return false;
                  }).
                  map((item, id) =>
                  <>
                                        <tr key={id}>
                                            <td>{t("legacy_candidato")}</td>

                                            <td>{item.name}</td>
                                            <td>{item.numero_inscricao}</td>
                                            <td>{item.email}</td>
                                            <td>{item.cpf}</td>
                                            <td>{`${t("legacy_sala")} `}{item.sala?.numero}</td>
                                            <td><StatusBadge {...getAttendanceStatus(item.status)} /></td>

                                            <td>
                                                <StatusBadge {...getReliabilityStatus(item.trust_points)} />
                                            </td>

                                            <td>
  <div className="actions-group">

                                                <a target="_blank" href={`${THIS_URL}candidatos_vinculados/show/${item.id}/${processo_id}`} onClick={(e) => e.stopPropagation()}>

                                                    <span

                            className="inline-flex align-center jcc bg-warning icon"
                            style={{ width: "2em", height: "2em", borderRadius: "7px" }}
                            title={t("legacy_gerenciar_candidato")}>

                                                        <BsFillEyeFill size={17} color="white" />
                                                    </span>
                                                </a>

  </div>
</td>

                                            {/* <td><img style={{ height: 60, width: 60, objectFit: 'contain' }} src={STORAGE_URL + STORAGE_URL + item.arquivo} /></td> */}



                                        </tr>
                                        <tr key={'2' + id}>
                                            <td>
                                                <b>{t("label_indexes")}:</b>
                                                 </td>
                                            <td colSpan={3}>

                                                <p style={{ marginBottom: 2 }}><b>{t("ui_acoes_reportadas_3b561a75")}</b> {item.trust.acoes_relatadas}</p>
                                                <p style={{ marginBottom: 2 }}><b>{t("ui_media_do_reconhecimento_facial_cda4999c")}</b> {100 - item.trust.average_face}</p>
                                                <p style={{ marginBottom: 2 }}><b>{t("ui_validacoes_faciais_periodicas_004cccb9")}</b> {item.trust.face_validaiton_again}</p>
                                                <p style={{ marginBottom: 2 }}><b>{t("label_photos_without_face")}:</b> {item.trust.no_face}</p>
                                                <p style={{ marginBottom: 2 }}><b>{t("ui_numero_de_pedidos_de_liberacao_para_o_fiscal_ae10b565")}</b> {item.trust.request_validation}</p>

                                            </td>
                                            <td colSpan={3}>

                                            <p style={{ marginBottom: 2 }}><b>{t("ui_saidas_de_tela_101c35f0")}</b> {item.trust.saidas}</p>
                                                <p style={{ marginBottom: 2 }}><b>{t("ui_tempo_de_saida_da_tela_de_prova_75e5fa8c")}</b> {item.trust.tempo}{t("unit_seconds_short")}</p>
                                                <p style={{ marginBottom: 2 }}><b>{t("ui_videos_sem_rosto_39a8f692")}</b> {item.trust.video_analyse.no_face}</p>
                                                <p style={{ marginBottom: 2 }}><b>{t("ui_multiplas_rostos_2288af49")}</b> {item.trust.video_analyse.multiple_faces_detected}</p>
                                                <p style={{ marginBottom: 2 }}><b>{t("ui_ips_identicos_a9e2cc1b")}</b> {item.trust.ip_equal}</p>
                                                <p style={{ marginBottom: 2 }}><b>{t("video_ai_events")}:</b> {item.trust.video_ai_events || 0}</p>
                                                <p style={{ marginBottom: 2 }}><b>{t("trust_video_ai_points")}:</b> {item.trust.video_ai_points || 0}</p>
                                                {getCandidateAIEventRows(item.trust).length > 0 && <div className="video-ai-event-summary-list mt-2">
                                                    {getCandidateAIEventRows(item.trust).map(event => (
                                                        <span key={event.eventType} className={event.enabled ? "video-ai-badge event" : "video-ai-badge neutral"}>
                                                            {event.label}: {event.total}
                                                        </span>
                                                    ))}
                                                </div>}

                                                </td>



                                        </tr>
                  </>

                  )}

                                </tbody>
                            </table>
                            {loading_candidatos == true &&
              <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                                    {/* <div className="spinner-border text-primary" role="status"  >
                    </div> */}
                                    <CircularProgress />
                                </div></div>

              }
                        </div>
                    </div>
                    {loading_candidatos == false && candidatos.filter((item, id) => {
            if (item.name.toLowerCase().includes(search_oficial.toLowerCase()) ||
            item.cpf.toLowerCase().includes(search_oficial.toLowerCase()) ||
            item.numero_inscricao.toLowerCase().includes(search_oficial.toLowerCase()) ||
            item.email.toLowerCase().includes(search_oficial.toLowerCase()))
            {
              return true;
            }
            return false;
          }).length == 0 && <div className="row">
                        <div className="col-12">
                            <TableEmptyState title={t("empty_no_candidate_found")} icon="📋" />

                        </div>
                    </div>}

                    <Pagination
            className={pagination.last_page == 1 ? "hide" : ""}
            style={{ display: "flex", justifyContent: "flex-end" }}
            count={pagination.last_page}
            value={pagination.current_page}
            onChange={(_, value) => {
              setLoadingcandidatos(true);
              console.log(_, value);
              let page = { ...pagination };
              page.current_page = value;
              setPagination(pagination);
              Getcandidatos(false, trustOptions);
            }} />


                    {/* {this.state.andamento == true && <AvaliacaoAndamento get_candidatos={this.get_candidatos.bind(this)} {...this.props} />} */}

                </div>}

                {loading_screen == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    {/* <div className="spinner-border text-primary" role="status"  >
              </div> */}
                    <span style={{ color: '#3f51b5' }}>{msgStatus}</span>
                    <CircularProgress style={{ marginLeft: 10 }} />
                </div></div>}

                <SweetAlert
          warning
          title={t("legacy_atencao")}
          onConfirm={() => {
            setShowWarning(false);
            setLoadingcandidatos(true);
            // this.delete_banner(this.state.banner_to_delete);
          }}
          onCancel={() => {
            setShowWarning(false);
          }}
          show={show_warning}
          confirmBtnText={t("ui_sim_desejo_desvincular_91364237")}
          cancelBtnText={t("legacy_cancelar")}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          showCancel={true}>{t("ui_ao_desvincular_este_candidato_ele_nao_tera_mais_ac_1d2c882c")}


        </SweetAlert>


            </div>

        </div>);

};

export default CandidatosConfiabilidade;
